import React, { Component } from 'react';
import Paper from 'material-ui/Paper';
import Modal from './ListName/Modals';
import Snackbar from 'material-ui/Snackbar';
import { FormattedMessage } from 'react-intl';
import { getToken } from '../../lib';
import UserTable from '../../components/UserTable/Table';

class ContactList extends Component {
  state = {
    open: false,
    user: null,
    snackbarOpen: false,
    snackbarMessage: '',
    listModalOpen: false,
    listModalPurpose: null,
    isEmpty: false,
    singleIconClick: false,
    username: null,
    email: null,
    password: null,
    role: null,
    fvdomain_id: null,
    userId: null
  };
  componentDidMount() {
    const token = getToken();
    if(this.props.domainId) {
      this.props.fetchUserList(token, this.props.domainId);
      this.setState({
        fvdomain_id: this.props.domainId
      })
    }
  }

  componentWillReceiveProps(newProps) {
    if(newProps.success){
      setTimeout(()  => this.handleListModalClose()
      ,2000)
    }
  }

  hadleListClick = (e, purpose) => {
    this.setState({ listModalOpen: true, listModalPurpose: purpose });
    this.props.clearErrors()
  }


  getSnackbarDetails = message => {
    this.setState({
      snackbarOpen: true,
      snackbarMessage: message
    });
  };
  editDetails = (username, email, fvlite_role, fvdomain_id, userId) => {
    this.props.clearErrors()
    this.setState({
      singleIconClick: true,
      username,
      email,
      fvlite_role,
      fvdomain_id,
      userId,
      listModalPurpose: 'editUser',
      listModalOpen: true
    });

  };

  handleClose = () => this.setState({ open: false });
  handleListModalClose = () => this.setState({ listModalOpen: false });

  handleDeleteTouch = (e, message, id, fvdomain_id) => {
    const token = getToken();
    this.setState({
      singleIconClick: true,
      selectedRows: [],
      snackbarOpen: true,
      snackbarMessage: message
    });
    e.target.style.fill = e.target.style.fill === 'red' ? '#afb8c5' : 'red';
    this.props.deleteUser(token, id, fvdomain_id);
  };

  render() {
    const { username, email, password, fvlite_role, fvdomain_id, userId } = this.state;
    const modalWidth = this.props.view === 'desktop' ? '442' : '94%';
    return (
      <div>
        <Paper className="pa3" style={{textAlign:"center"}}>
        <UserTable
          {...this.props}
          handleDeleteTouch={this.handleDeleteTouch}
          handleListModalClose={this.handleListModalClose}
          handleClose={this.handleClose}
          hadleListClick={this.hadleListClick}
          editDetails={this.editDetails} />
          
        </Paper>
          {false && <Snackbar
            style={{ left: 200, bottom: 30 }}
            open={this.state.snackbarOpen}
            message={this.state.snackbarMessage}
            action={<FormattedMessage id="seminarActions.dismiss" />}
            onActionTouchTap={this.handleRequestClose}
            autoHideDuration={4000}
            onRequestClose={this.handleRequestClose}
          />}
          <Modal
            fetchUserDetails={this.props.fetchUserDetails}
            editUser={this.props.editUser}
            addUser={this.props.addUser}
            purpose={this.state.listModalPurpose}
            open={this.state.listModalOpen}
            handleClose={this.handleListModalClose}
            snackbarOpen={this.getSnackbarDetails}
            user={{ username, email, fvlite_role, password, fvdomain_id, userId }}
            fvdomain_id={fvdomain_id}
            errors={this.props.errors}
            success={this.props.success}
            hasServerError={this.props.hasServerError}
            modalWidth={modalWidth}
            msg={this.props.msg}
          />
      </div>
    );
  }
}

export default ContactList;



// WEBPACK FOOTER //
// src/routes/Users/Users.js